// extracted by mini-css-extract-plugin
export var button = "_lw-2";
export var card = "_lw-0";
export var closeButtonContainer = "_lw-3";
export var iconContainer = "_lw-1";